'use client'

import classNames from 'classnames'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'

import Link from '~/components/link'
import { onScroll } from '~/utils/scroll'

const HeaderContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isTransparent, setTransparent] = useState(false)
  const path = usePathname()

  useEffect(() => {
    const isHome = path === '/'
    if (!isHome) {
      setTransparent(false)
      return
    }
    return onScroll((scrollPosition) => {
      setTransparent(scrollPosition < 40)
    })
  }, [path])

  return (
    <header
      className={classNames(
        'fixed h-[4.375rem] text-neutral-white z-50 top-0 left-0 w-full transition-[background-color,box-shadow] duration-300 ease-out',
        {
          'bg-wine-1000 shadow-lg': !isTransparent,
          'bg-transparent': isTransparent,
        }
      )}
    >
      {children}
    </header>
  )
}

export default HeaderContainer
